import React from 'react'
import SearchIcon from '@mui/icons-material/Search';
import TextField from "@mui/material/TextField";
import { makeStyles } from '@mui/styles';
import InputAdornment from '@mui/material/InputAdornment';
import { padding } from '@mui/system';


const useStyles = makeStyles((theme) => ({
    textField: {
        background: "#F2F4F7 !important",
        // border: '1px solid #D0D5DD !important',
        boxSizing: 'border-box',
        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        borderRadius: '0.8rem',
        padding: "0 !important"
    },
    input: {
        background: '#F2F4F7',
        borderRadius: '0.8rem !important',
        border: '1px solid #F2F4F7',
        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
        "&.Mui-focused": {
            background: "#fff !important",
            border: "1px solid #84CAFF !important",
            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none"
        },          
        "&:hover": {
            // border:"none",
            '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #F2F4F7 !important'
            }
        },
        '& input': {
            padding: '1rem 1.4rem !important',
            lineHeight: '2.4rem',
            fontSize: '1.6rem',
            paddingLeft: "0 !important",
            border: "none !important",
            boxShadow: "none !important",
        }
    }
}));

export default function SearchBar({ placeholder, search, width, id, sxStyle }) {
    const classList = useStyles();
    return (
        <TextField className={classList.textField} style={{ width: width }}
            id={"input-with-icon-textfield "+id}
            placeholder={placeholder} onChange={search}
            // value={value}
            InputProps={{
                className: classList.input,
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon style={{ color: "#667085", width: "3rem", height: "3rem" }} />
                    </InputAdornment>
                ),
            }}
            variant="outlined"
            sx={[sxStyle]}
        />
    )
}
